/**
 * @generated SignedSource<<a6cf3613801c63f006ac4b9e76375eaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItems_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
  readonly " $fragmentType": "PdpRespSellerItems_user";
};
export type PdpRespSellerItems_user$key = {
  readonly " $data"?: PdpRespSellerItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItems_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a870e43d449884562f281bc5391a86ee";

export default node;
